module.exports = __webpack_public_path__ + "img/empty.a2689eb1.png";